
import { Component, Inject } from 'vue-property-decorator';
import { Navigator, Service } from '@/domain/providers';
import type { Navigation } from 'zr-arch';
import Services from '@/infrastructure/service';
import Vue from 'vue';

@Component
export default class PromptLogin extends Vue {
    @Inject(Service) service!: Services;
    @Inject(Navigator) navigator!: Navigation;

    mounted(): void {
        this.service.授权.login();
    }
}
